export default __webpack_public_path__ + "assets/94154b3a30fc2a6de53989dec3cd5d7f.jpg";